import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { AggregationService } from '../_services/aggregation.service';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { LocalStorageService } from '../_services/local-storage.service';
import { ExportPayload, PersonSearchService } from '../_services/person-search.service';
import * as _ from 'underscore';
import { AggReqObjectHandlerService } from '../_services/agg-req-object-handler.service';
import { StatsMatrixHandlerService } from '../_services/stats-matrix-handler.service';
import { GlobalService } from '../_services/global.service';
import { JdDataService } from '../jd-data.service';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { InsightsDataService } from '../_services/insights-data.service';


@Component({
    selector: 'app-person-search-ai',
    templateUrl: './person-search-ai.component.html',
    styleUrls: ['./person-search-ai.component.scss'],
    standalone: false
})
export class PersonSearchAiComponent implements OnInit {

  companyname: any;
  @Input() requestaidata;
  @Input() insightstabname;
  statsdata: any;
  @Input() totalcount;
  aidata: any = ''
  filterdata: any;
  locationsfilterdata: any = [];
  skillsfilterdata: any = [];
  functionsfilterdata: any = [];
  aifilter: any
  showshimmerloader: boolean = false;
  quicksearchdata: any;
  @Input() keyword;
  @Input() insightsaidata;
  @Input() events: Observable<void>;
  @Input() isSimilarCandidatesFlow: boolean = false;
  @Input() isJDFlow: boolean = false;
  totalTenureMedian: any;
  changedJobs: any;
  insightsdata: any = '';
  aisubscription: Subscription;
  refreshAi: boolean = false;
  successMessage: string = "";
  errorMessage: string = "";
  insightsExportSubscription: Subscription = null;

  constructor(private router: Router, private personsearchservice: PersonSearchService, private localstorageservice: LocalStorageService,
    private aggregationservice: AggregationService, private filterDataHandlerService: FilterDataHandlerService, private route: ActivatedRoute,
    private insightsdataservice: InsightsDataService, private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private statsMatrixHandlerService: StatsMatrixHandlerService, private jdDataService: JdDataService, private similarCandidateService: SimilarCandidateService) {


    this.insightsdataservice.fetchRefreshAiData().subscribe((res) =>{
      if (res.data) {
        this.refreshAi = res.data;
        this.events.subscribe((event: any) => {
          this.insightsdata = event;
          if (event) {
            const locations = event.topLocations.map(elm => ({ Location: elm.key, 'Talent Count': elm.doc_count }));
            const companies = event.dataSourceCurrentCompany && event.dataSourceCurrentCompany.data.map(elm => ({ Company: elm.label, 'Talent Count': elm.value }));
            const industries = event.currentIndustry && event.currentIndustry.map(elm => ({ Industry: elm.key, 'Talent Count': elm.doc_count }));
            const schools = event.school && event.school.map(elm => ({ Schools: elm.key, 'Talent Count': elm.doc_count }));
            const fieldofstudies = event.fieldOfStudy && event.fieldOfStudy.map(elm => ({ 'Field of Study': elm.key, 'Talent Count': elm.doc_count }));
            const skills = event.skills && event.skills.map(elm => ({ 'Skills': elm.key, 'Talent Count': elm.doc_count }));
            const jobtitles = event.titles && event.titles.map(elm => ({ 'Job Title': elm.key, 'Talent Count': elm.doc_count }));
            const totaltenure = event.dataSourceCurrentExperience && event.dataSourceCurrentExperience.data && event.dataSourceCurrentExperience.data.map(elm => ({ 'Total Tenure': elm.label, 'Talent Count': elm.value }))
            const currenttenure = event.dataSourceExpInCurrentRole && event.dataSourceExpInCurrentRole.data && event.dataSourceExpInCurrentRole.data.map(elm => ({ 'Tenure in current company': elm.label, 'Talent Count': elm.value }))
            const seniority = event.dataSourceSeniority && event.dataSourceSeniority.data && event.dataSourceSeniority.data.map(elm => ({ 'Seniority': elm.label, 'Talent Count': elm.value }))


            this.quicksearchdata = {
              locations: locations,
              companies: companies,
              industries: industries,
              schools: schools,
              fieldofstudies: fieldofstudies,
              skills: skills,
              jobtitles: jobtitles,
              totaltenures: totaltenure,
              currenttenures: currenttenure,
              seniority: seniority,
              // nationality: nationality,
              // ethnicity: ethnicity

            }
          }
        })
        // this.aggregationservice.getStatsAggs();
        this.aggregationservice.statsUpdateEvent.subscribe(res => this.getcountdata(res));
        this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.getfilterdata());
        this.keyword = this.route.snapshot.queryParams.keyword;
      }
    })

  }

  ngOnInit() {
    this.events.subscribe((event: any) => {
      this.insightsdata = event;
      if (event) {
        const locations = event.topLocations.map(elm => ({ Location: elm.key, 'Talent Count': elm.doc_count }));
        const companies = event.dataSourceCurrentCompany && event.dataSourceCurrentCompany.data.map(elm => ({ Company: elm.label, 'Talent Count': elm.value }));
        const industries = event.currentIndustry && event.currentIndustry.map(elm => ({ Industry: elm.key, 'Talent Count': elm.doc_count }));
        const schools = event.school && event.school.map(elm => ({ Schools: elm.key, 'Talent Count': elm.doc_count }));
        const fieldofstudies = event.fieldOfStudy && event.fieldOfStudy.map(elm => ({ 'Field of Study': elm.key, 'Talent Count': elm.doc_count }));
        const skills = event.skills && event.skills.map(elm => ({ 'Skills': elm.key, 'Talent Count': elm.doc_count }));
        const jobtitles = event.titles && event.titles.map(elm => ({ 'Job Title': elm.key, 'Talent Count': elm.doc_count }));
        const totaltenure = event.dataSourceCurrentExperience && event.dataSourceCurrentExperience.data && event.dataSourceCurrentExperience.data.map(elm => ({ 'Total Tenure': elm.label, 'Talent Count': elm.value }))
        const currenttenure = event.dataSourceExpInCurrentRole && event.dataSourceExpInCurrentRole.data && event.dataSourceExpInCurrentRole.data.map(elm => ({ 'Tenure in current company': elm.label, 'Talent Count': elm.value }))
        const seniority = event.dataSourceSeniority && event.dataSourceSeniority.data && event.dataSourceSeniority.data.map(elm => ({ 'Seniority': elm.label, 'Talent Count': elm.value }))
        // const nationality = event?.dataSourceNationality && event.dataSourceNationality.data.map( ele =>  ({Nationality : ele.label, 'Talent Count' : ele.value + '%'}));
        // const ethnicity = event?.dataSourceEthnicity && event.dataSourceEthnicity.data.map(ele => ({Ethnicity: ele.label, 'Talent Count': ele.value + '%'}));

        this.quicksearchdata = {
          locations: locations,
          companies: companies,
          industries: industries,
          schools: schools,
          fieldofstudies: fieldofstudies,
          skills: skills,
          jobtitles: jobtitles,
          totaltenures: totaltenure,
          currenttenures: currenttenure,
          seniority: seniority,
          // nationality: nationality,
          // ethnicity: ethnicity

        }
      }
    })
    this.aggregationservice.getStatsAggs();
    this.aggregationservice.statsUpdateEvent.subscribe(res => this.getcountdata(res));
    this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.getfilterdata());
    this.keyword = this.route.snapshot.queryParams.keyword;

    // subscribe to insights-export subject for receiving data from tab-level component
    this.insightsExportSubscription = this.personsearchservice.insightsExportDataEvent.subscribe((payloadData: ExportPayload) => {
      this.exportToPDF(payloadData);
    });
  }

  ngOnDestroy() {
    this.insightsExportSubscription.unsubscribe();
  }

  generateai() {
    this.showshimmerloader = true;
    this.keyword = this.route.snapshot.queryParams.keyword;
    this.aidata = '';
    const payload = {
      data: this.quicksearchdata,
      filters: this.aifilter,
      totaltenuremedian: this.totalTenureMedian,
      talentcount: this.totalcount,
      changedjobscount: this.changedJobs,
      changedjobsdurationinmonths: 12,
      booleanquery: this.keyword ? this.keyword: '*'

    }
    this.aisubscription = this.personsearchservice.getquicksearchsummary(payload).subscribe((res: any) => {
      this.aidata = res.data;
      this.showshimmerloader = false
      this.aidata = this.aidata.replace(/(?:\r\n|\r|\n)/g, '<br>').replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    })
  }

  getfilterdata() {

    this.filterdata = this.filterDataHandlerService.fetchFilterData;
    this.aifilter = {
      locations: this.filterdata && this.filterdata.locationSelectedList.length ? this.filterdata.locationSelectedList.filter(l => l.isExcluded == false).map(l => l.key) : [],
      functions: this.filterdata && this.filterdata.functionSelectedList ? this.filterdata.functionSelectedList.map(l => l.key) : [],
      preferredskills: this.filterdata && this.filterdata.skillsSelectedList.length ? this.filterdata.skillsSelectedList.filter(s => s.isMandatory == false).map(s => s.key) : [],
      jobtitles: this.filterdata && this.filterdata.jobTitleSelectedList.length ? _.uniq(this.filterdata.jobTitleSelectedList.filter(jobTitle => jobTitle.isExcluded == false).map(j => j.key)) : [],
      companies: this.filterdata && this.filterdata.companySelectedList.length ? this.filterdata.companySelectedList.filter(company => company.isExcluded == false).map(j => j.key) : [],
      companysizes: this.filterdata.companysize ? [this.filterdata.companysize] : [],
      industries: this.filterdata && this.filterdata.industrySelectedList.length ? this.filterdata.industrySelectedList.map(industry => industry.key) : [],
      seniorities: this.filterdata.seniority.length ? _.flatten(this.filterdata.seniority) : [],
      genders: this.filterdata.gender ? [this.filterdata.gender] : [],
      educationaldegrees: this.filterdata.educationSelectedList.length ? this.filterdata.educationSelectedList.map(e => e.key) : [],
      schools: this.filterdata.schoolSelectedList.length ? this.filterdata.schoolSelectedList.map(s => s.key) : [],
      fieldofstudies: this.filterdata.fieldOfStudySelectedList.length ? this.filterdata.fieldOfStudySelectedList.map(fs => fs.key) : [],
      likelytomovetypes: this.filterdata.candidateslikelytomove ? [this.filterdata.candidateslikelytomove] : [],
      fromyearsofexperiences: this.filterdata && this.filterdata.yearsofexperienceFrom ? [this.filterdata.yearsofexperienceFrom] : [],
      toyearsofexperiences: this.filterdata && this.filterdata.yearsofexperienceTo ? [this.filterdata.yearsofexperienceTo] : [],
      currentfromyearsofexperiences: this.filterdata && this.filterdata.currentfromyearsofexperience ? [this.filterdata.currentfromyearsofexperience] : [],
      currenttoyearsofexperiences: this.filterdata && this.filterdata.currenttoyearsofexperience ? [this.filterdata.currenttoyearsofexperience] : [],
      mandatoryskills: this.filterdata.skillsSelectedList.length ? this.filterdata.skillsSelectedList.filter(s => s.isMandatory == true).map(s => s.key) : []
    }
    this.aidata = '';
    this.showshimmerloader = false;
    if(this.aisubscription)
      this.aisubscription.unsubscribe();
  }

  getcountdata(res) {
    const response = res.find(el => !!el.data.aggregations.total_tenure_median);
    this.totalTenureMedian = response.data && response.data.aggregations && response.data.aggregations.total_tenure_median && response.data.aggregations.total_tenure_median.value || 0;

    const changeddata = res.find(el => !!el.data.aggregations.changedjobs);
    this.changedJobs = changeddata.data && changeddata.data.aggregations && changeddata.data.aggregations.changedjobs && changeddata.data.aggregations.changedjobs.doc_count;

  }

  /**
   * Request insights export from currently active tab
   */
  requestInsightsExport() {
    this.personsearchservice.sendInsightsExportRequest({ type: 'SIGNAL', action: '', data: { currentTab: 'insights' } });
  }

  /**
   * Initiate insights export using received payload
   * @param payloadData
   */
  exportToPDF(payloadData: any) {
    const filtersData = this.filterDataHandlerService.fetchFilterData;
    const sharedReqData = this.aggReqObjectHandlerService.getSharedRequestObject();
    const matrixData = this.statsMatrixHandlerService.matrixStaticData;
    matrixData['medianTenure'] = GlobalService.convertNumberToYearsAndMonths(matrixData.totalMedianTanureCount);
    matrixData['talentCount'] = GlobalService.formatNumberToIndianFormat(matrixData.totalCandidatesCount);

    // remove "searchastext" from filter data, excluded filters & perform basic transformations/changes
    const excludedJobtitles = sharedReqData?.exclude_jobtitles?.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean) || [];
    const excludedLocations = sharedReqData?.exclude_locations?.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean) || [];
    const mandatorySkills = sharedReqData?.mandatoryskills?.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean) || [];
    const excludedPreferredSkills = sharedReqData?.exclude_preferredskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedMandatorySkills  = sharedReqData?.exclude_mandatoryskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedFunctions  = sharedReqData?.exclude_functions.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedCompanies = sharedReqData?.exclude_companies.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedIndustries = sharedReqData?.exclude_industries.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedSchools = sharedReqData?.exclude_schoollocation.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedPastJobTitles = sharedReqData?.exclude_pastjobtitles.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    Object.entries(filtersData).forEach(([key, value]) => {
      if(value && Array.isArray(value)) {
        filtersData[key] = (Array.isArray(value) ? value : [value]).filter(Boolean).map((s) =>
        {
          if (typeof s === 'string') {
            if (s.includes('.searchastext')) {
              return s.split('.searchastext')[0];
            } else {
              return s.split('.aisearch')[0];
            }
          } else {
            if (s.key.includes('.searchastext')) {
              return s.key.split('.searchastext')[0];
            } else {
              return s.key.split('.aisearch')[0];
            }
          }
        });

        if(key === 'seniority' || key === 'companysize'){
          filtersData[key] = filtersData[key].filter(item => (item.toLowerCase() != 'all'));
        } else if(key === 'jobTitleSelectedList') {
          filtersData[key] = filtersData[key].filter(item => !excludedJobtitles.includes(item.toLowerCase()));
        } else if(key === 'locationSelectedList') {
          filtersData[key] = filtersData[key].filter(item => !excludedLocations.includes(item.toLowerCase()));
        } else if (key === 'skillsSelectedList') {
  filtersData[key] = filtersData[key]
    .filter(item => {
      const skill = item?.toLowerCase();

      return !(
        excludedPreferredSkills.includes(skill) ||
        excludedMandatorySkills.includes(skill)
      );
    })
    .map(item => {
      const skill = item?.toLowerCase();

      return {
        key: item,
        isMandatory: mandatorySkills.includes(skill)
      };
    });
} else if (key === 'functionSelectedList') {
          filtersData[key] = filtersData[key].filter(item => !excludedFunctions.includes(item.toLowerCase()));
        }
      }
    });

    filtersData['excludedJobtitles'] = excludedJobtitles;
    filtersData['excludedLocations'] = excludedLocations;
    filtersData['excludedCompanies'] = excludedCompanies;
    filtersData['excludedIndustries'] = excludedIndustries;
    filtersData['excludedSchools'] = excludedSchools;
    filtersData['excludedPastJobTitles'] = excludedPastJobTitles;
    filtersData['excludedPreferredSkills'] = excludedPreferredSkills;
    filtersData['excludedMandatorySkills'] = excludedMandatorySkills;
    filtersData['excludedFunctions'] = excludedFunctions;


    // handle male/female change to men/women
    if(filtersData?.['gender']?.toLowerCase() == 'male') filtersData['gender'] = 'Men';
    else if(filtersData?.['gender']?.toLowerCase() == 'female') filtersData['gender'] = 'Women';

    //Continent sent in export payoload for talent-insights
    filtersData.continentstobeincluded = (Array.isArray(payloadData.continentstobeincluded) ? payloadData.continentstobeincluded : [payloadData.continentstobeincluded]).filter(Boolean);
    delete payloadData.continentstobeincluded;

    if(this.jdDataService.isComingFromJobDescription || this.isJDFlow) {
      filtersData['JD_KEYS'] = this.jdDataService.jdDataFromSession;
    }
    if(this.isSimilarCandidatesFlow) {
      filtersData['SIMILAR_CANDIDATES_KEYS'] = this.similarCandidateService.getSimilarCandidatesData?.data ? { ...this.similarCandidateService.getSimilarCandidatesData?.data, fullname: this.similarCandidateService.getSimilarCandidatesData?.data.fullname.trim() } : {};
    }

    const payloadForExport: ExportPayload = {
      data: {
        ...payloadData,
        filters: filtersData,
        matrixData: matrixData
      }
    }
    if(this.aidata) {
      payloadForExport.data['aiData'] = this.aidata;
    } else {
      this.getfilterdata();
      payloadForExport.data['aiData'] = null;
      payloadForExport.data['aiRequestFilters'] = this.aifilter;
      payloadForExport.data['aiRequestPayload'] = this.insightsaidata || {};
    }

    // service call for export
    this.personsearchservice.exportInsightsToPDFReport(payloadForExport).subscribe((res: any) => {
      if(res) {
        if(res.status === 'failure') {
          this.errorMessage = 'Error occured while generating the report';
        } else {
          this.successMessage = 'You will receive the person-search insights report on your email in a min.';
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      } else {
        this.errorMessage = 'Error occured while generating the report';
      }
    }, () => {
      this.errorMessage = 'Error occured while generating the report';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    });
  }


}
